module.exports = __webpack_public_path__ + "static/media/lauren_serious.0906b2ed.png";